import { useLocation } from "react-use"

export const useTemplateIdFromUrl = () => {
  const { search } = useLocation()
  const templateId = new URLSearchParams(search).get("templateId") ?? ""

  return templateId
}
